import { APIMethod, fetchData } from "@client";

/**
 * Invite external contractor to workspace
 * @param {string} email - Contractor email
 * @param {string[]} projectUuids - Array of project UUIDs to assign (optional)
 * @returns {Promise<Object>} Response with contractor data
 */
export async function inviteContractorQuery(email, projectUuids = []) {
  const data = {
    email,
    projectUuids: JSON.stringify(projectUuids),
  };

  console.log("inviteContractorQuery - sending data:", data);

  try {
    const res = await fetchData("/team/invite-contractor", APIMethod.POST, {
      data,
      removeEmptyKeys: true,
      mapRequestKeysToSnakeCase: false,
    });
    console.log("inviteContractorQuery - response:", res);
    return { email, hasError: false, user: res?.results || null };
  } catch (error) {
    console.error("inviteContractorQuery - error:", error);
    return {
      email,
      hasError: true,
      errorMessage: error?.response?.data?.error || error?.message
    };
  }
}

